module.exports = __webpack_public_path__ + "assets/images/project/satellite-gifs/meta.gif?v=a2440714";